module.exports = {"id":"199058","name":"Sergey Tkachev","rating":"71","photo":"./data/images/photos/1/199058.png","club":{"name":"Arsenal Tula","logo":"./data/images/clubs/ArsenalTula.png"},"positions":["MD","MG","MOC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SergeyTkachev0.json
// module id = 3905
// module chunks = 0